export default __webpack_public_path__ + "static/media/arras10.52ed6d36.jpg";